<template>
    <div>
        <h6 class="">{{ $t(`${configId}.upload.title`) }}</h6>
        <hr class="mt-2" />
        <div class="row">
            <div class="col-sm-4">
                <MaterialSelect
                    :disabled="disabled"
                    class="city-form-group city-bg"
                    id="input-upload"
                    name="upload"
                    label="name"
                    :filterable="true"
                    :options="lists.onoff"
                    v-model.trim="form.status"
                    :reduce="option => option.code"
                    :data-vv-scope="vScope"
                    v-validate="'required'"
                    :inputClasses="[{'is-invalid': fnHasError('upload', vScope) }]"
                    :error=" fnFirstError('upload', vScope)"
                    :helpText="helpUpload.status">
                    {{ $t(`${configId}.upload.model.status`) }}
                </MaterialSelect>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="number"
                        class="city-form-group city-bg"
                        id="input-minfeatures"
                        name="minfeatures"
                        v-model.trim="form.minfeatures"
                        :data-vv-scope="vScope"
                        v-validate="{'required': true, 'integer': true, 'min_value': minFeatures}"
                        :inputClasses="[{'is-invalid': fnHasError('minfeatures', vScope) }]"
                        :error=" fnFirstError('minfeatures', vScope)"
                        :helpText="helpUpload.minfeatures">
                        {{ $t(`${configId}.upload.model.minfeatures`) }}
                    </MaterialInput>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="number"
                        class="city-form-group city-bg"
                        id="input-maxfeatures"
                        name="maxfeatures"
                        v-model.trim="form.maxfeatures"
                        :data-vv-scope="vScope"
                        v-validate="{'required': true, 'integer': true, 'min_value': form.minfeatures}"
                        :inputClasses="[{'is-invalid': fnHasError('maxfeatures', vScope) }]"
                        :error=" fnFirstError('maxfeatures', vScope)"
                        :helpText="helpUpload.maxfeatures">
                        {{ $t(`${configId}.upload.model.maxfeatures`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-filterProperty"
                        name="filterProperty"
                        v-model.trim="form.filterProperty"
                        :data-vv-scope="vScope"
                        v-validate="rulesUploadFilterName"
                        :inputClasses="[{'is-invalid': fnHasError('filterProperty', vScope) }]"
                        :error=" fnFirstError('filterProperty', vScope)"
                        :helpText="helpUpload.filterProperty">
                        {{ $t(`${configId}.upload.model.filterProperty`) }}
                    </MaterialInput>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <MaterialInput
                        :readonly="disabled"
                        :disabled="disabled"
                        type="text"
                        class="city-form-group city-bg"
                        id="input-filterBoundary"
                        name="filterBoundary"
                        v-model.trim="form.filterBoundary"
                        :data-vv-scope="vScope"
                        v-validate="rulesUploadFilterProperty"
                        :inputClasses="[{'is-invalid': fnHasError('filterBoundary', vScope) }]"
                        :error=" fnFirstError('filterBoundary', vScope)"
                        :helpText="helpUpload.filterGeneralBoundary">
                        {{ $t(`${configId}.upload.model.filterBoundary`) }}
                    </MaterialInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ManagePrintElementMixin from '../mixins/ManagePrintElementMixin';

export default {
    name: 'ConfigUploadGeneral',
    mixins: [
        ManagePrintElementMixin,
    ],
    props: {
        minFeatures: {
            type: Number,
            default: 0
        },
        uploadHelp: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                status: 0,
                minfeatures: 2,
                maxfeatures: 2,
                filterProperty: null,
                filterBoundary: null,
            },
        }
    },
    computed: {
        helpUpload() {
            return this.uploadHelp ?? this.$t(`${this.configId}.upload.help`);
        },
        rulesUploadFilterName() {
            return {
                'required': false,//this.form.status == 1,
                'min': 3,
                'regex': /^([A-Za-z0-9, ]+)$/,
            };
        },
        rulesUploadFilterProperty() {
            return {
                'required': false,//this.form.status == 1,
                'min': 3,
                'regex': /^([A-Za-z0-9-_]+)$/,
            };
        },
    },
}
</script>
